import React from "react";
import Sparkline from "@/components/Sparkline";

export default function KPICard({ label, value, unit, delta, deltaLabel, series, color = "#00FA9A", testid }) {
  const isUp = typeof delta === "number" && delta > 0;
  const isDown = typeof delta === "number" && delta < 0;
  return (
    <div className="eid-card p-4 flex flex-col gap-3" data-testid={testid}>
      <div className="flex items-start justify-between gap-2">
        <div className="eid-label">{label}</div>
        {typeof delta === "number" && (
          <span
            className={`font-mono text-xs px-1.5 py-0.5 rounded-sm ${
              isDown ? "bg-[#FF5500]/10 text-[#FF7A45]" : isUp ? "bg-[#00FA9A]/10 text-[#00FA9A]" : "bg-[#161616] text-zinc-400"
            }`}
          >
            {delta > 0 ? "+" : ""}
            {delta}
            {deltaLabel || ""}
          </span>
        )}
      </div>
      <div className="flex items-baseline gap-2">
        <div className="eid-value text-3xl leading-none tracking-tight">{value}</div>
        {unit && <div className="eid-label">{unit}</div>}
      </div>
      <div>
        <Sparkline values={series} width={240} height={36} stroke={color} />
      </div>
    </div>
  );
}
